const initialState = {
	allProducts: [],
	singleProduct: null,
	loading: false,
};
const productReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_PRODUCT_REQUEST':
			return {
				...state,
				loading: true,
			};
		case 'ADD_PRODUCT_SUCCESS':
			return {
				...state,
				loading: false,
			};
		case 'GET_ALL_PRODUCT':
			return {
				...state,
				allProducts: action.payload,
			};
		case 'GET_SINGLE_PRODUCT':
			return {
				...state,
				singleProduct: action.payload,
			};
		case 'UPDATE_PRODUCT':
			return {
				...state,
			};
		case 'DELETE_PRODUCT':
			return {
				...state,
			};

		default:
			return state;
	}
};

export default productReducer;
